import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class PublicPinDeleteAPICall extends APICallV4 {
    _method = 'public/pin/delete';
    _type: Method = 'post';
    _retriesCount = 0;
}
